import { zonedWallClock } from "../time-zone-rules";

const pad = (value: number, width = 2) => String(value).padStart(width, "0");

/** `YYYY-MM-DDTHH:MM` wall time of an instant, from tzdata 2026e's changes over the runtime's data (lib/time-zone-rules.ts). */
function localMinute(instant: number, timezone: string): string {
  const wall = zonedWallClock(instant, timezone);
  return `${pad(wall.year, 4)}-${pad(wall.month)}-${pad(wall.day)}T${pad(wall.hour)}:${pad(wall.minute)}`;
}

/** Destination-local wall times can have zero, one or two UTC instants at DST changes. */
export function localTimeCandidates(value: string, timezone: string): string[] {
  if (!/^20\d{2}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value) || !timezone || /^[+-]/.test(timezone)) return [];
  const nominal = Date.parse(`${value}:00Z`);
  if (!Number.isFinite(nominal) || new Date(nominal).toISOString().slice(0, 16) !== value) return [];
  try {
    const format = (instant: number) => localMinute(instant, timezone);
    const offsets = new Set<number>();
    for (let hours = -48; hours <= 48; hours += 6) {
      const sample = nominal + hours * 3_600_000;
      offsets.add(Date.parse(`${format(sample)}:00Z`) - sample);
    }
    return [...offsets].map(offset => nominal - offset).filter(instant => format(instant) === value)
      .sort((a, b) => a - b).map(instant => new Date(instant).toISOString());
  } catch { return []; }
}

export function instantToLocalInput(value: string | null | undefined, timezone: string): string {
  if (!value || !Number.isFinite(Date.parse(value))) return "";
  try {
    return localMinute(Date.parse(value), timezone);
  } catch { return ""; }
}
